document.addEventListener('DOMContentLoaded', () => {
  const buyNowButton = document.getElementById('btnBuyNow');
  // const radios = document.querySelectorAll('input[type="radio"][name="Gender"]');  
  
  if (buyNowButton) {
    buyNowButton.addEventListener('click', async () => {
      const form = buyNowButton.closest('form');
      const formData = new FormData(form);
      console.log("Form Data =>", formData);
      try {
        const response = await fetch('/cart/clear.js', { method: 'POST' });
        await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        window.location.href = '/checkout';
      } catch (error) {
        console.error('Buy Now error:', error);
      }
    });

    // radios.forEach(function(radio) { 
    //   console.log(radio);
    //   radio.addEventListener('change', function() {  
    //     buyNowButton.disabled = false;  
    //   });  
    // }); 
  }
  
});